function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 10,
  r: 9.5,
  fill: "#5E5E5E",
  stroke: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.92969 14V5.46875H10.918C11.9531 5.46875 12.7383 5.66797 13.2734 6.06641C13.8086 6.46094 14.0762 7.04102 14.0762 7.80664C14.0762 8.22461 13.9688 8.59375 13.7539 8.91406C13.5391 9.23047 13.2402 9.46289 12.8574 9.61133C13.2949 9.7207 13.6387 9.94141 13.8887 10.2734C14.1426 10.6055 14.2695 11.0117 14.2695 11.4922C14.2695 12.3125 14.0078 12.9336 13.4844 13.3555C12.9609 13.7773 12.2148 13.9922 11.2461 14H7.92969ZM9.6875 10.2852V12.5879H11.1934C11.6074 12.5879 11.9297 12.4902 12.1602 12.2949C12.3945 12.0957 12.5117 11.8223 12.5117 11.4746C12.5117 10.6934 12.1074 10.2969 11.2988 10.2852H9.6875ZM9.6875 9.04297H10.9883C11.875 9.02734 12.3184 8.67383 12.3184 7.98242C12.3184 7.5957 12.2051 7.31836 11.9785 7.15039C11.7559 6.97852 11.4023 6.89258 10.918 6.89258H9.6875V9.04297Z",
  fill: "white"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 22,
  height: 22,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgTripB({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripB);
export default __webpack_public_path__ + "static/media/trip-b.7aae21ee150bcdec409513a1951e0971.svg";
export { ForwardRef as ReactComponent };